export default "__VITE_ASSET__jpkt54SW__"